import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import classes from './ChatFooter.module.css';
import { ReactComponent as SendIcon } from '../../../assets/icons/send-icon.svg';

const ChatFooter = (props) => {

  const {t} = useTranslation('global');

  const [inputEnabled, setInputEnabled] = useState(false);
  const textInput = useRef(null);

  const submitHandler = () => {
    const inputText =  textInput.current.value;
    textInput.current.value = '';
    props.send(inputText);
    setInputEnabled(false);
  };

  const handleKeypress = e => {
    //it triggers by pressing the enter key
    if (e.charCode === 13) {
      submitHandler();
    }
  };

  const inputFocusHandler = e => {
    setInputEnabled(true);
  }
  const inputBlurHandler = e => {
    setInputEnabled(false);
  }

  const footerBorderClasses = [classes.FooterBorder];
  
  if (inputEnabled){
    footerBorderClasses.push(classes.InputEnabled);
  }

  return (
    <div className={classes.ChatFooter} role="region" aria-labelledby="chatFooterTitle">
      <h3 id="chatFooterTitle" className="sr-only"> {t('chatfooter.title')} </h3>
      <div className={footerBorderClasses.join(' ')}></div>
      <input 
        className = {classes.Input}
        type="text"
        placeholder={t('chatfooter.input.placeholder')}
        onKeyPress={handleKeypress}
        onFocus={inputFocusHandler}
        onBlur={inputBlurHandler}
        ref={textInput}
        title={t('chatfooter.input.title')} 
        aria-label={t('chatfooter.input.title')}
        />
      <button 
        className={classes.SendButton}
        title={t('chatfooter.send')} 
        aria-label={t('chatfooter.send')}
        aria-disabled={!inputEnabled}
        onClick={submitHandler}>
          <SendIcon/>
        </button>
    </div>
  )
}



export default ChatFooter;